import { render, staticRenderFns } from "./ReportsUser.vue?vue&type=template&id=2a6547b8&"
import script from "./ReportsUser.vue?vue&type=script&lang=js&"
export * from "./ReportsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports